"use client";

import React from "react";
import { BlogConclusion } from "@/.storyblok/types/319751/storyblok-components";
import { storyblokEditable, SbBlokData } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";

interface BlogConclusionProps {
  blok?: BlogConclusion & SbBlokData;
}

const BlogConclusionComponent: React.FC<BlogConclusionProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, content } = blok;

  const conclusionId = title
    ? title
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
    : "conclusion";

  return (
    <div
      {...(blok && storyblokEditable(blok))}
      className="bg-light component-simple-content py-4 py-md-5"
    >
      <div className="container max-two-thirds">
        <h2 className="mb-4" id={conclusionId}>
          {title}
        </h2>
        {content && (
          <div className="lead blog-conclusion-content">
            {Array.isArray(content) ? (
              content.map((richTextBlock, index) => (
                <div
                  key={index}
                  className="mb-3"
                  dangerouslySetInnerHTML={{
                    __html: renderRichText(richTextBlock),
                  }}
                />
              ))
            ) : (
              <div
                dangerouslySetInnerHTML={{ __html: renderRichText(content) }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogConclusionComponent;
